/*
 *****************************************************************************
 *File : base.js
 *Module : Dashboard Frontend
 *Purpose : Base js File
 *Author : UI Team
 *Copyright : Copyright 2021, Lab to Market Innovations Private Limited
 *****************************************************************************
 */

import Vue from 'vue';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';

const requireComponent = require.context('@/components/base', true, /\.vue$/);

requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName);

  const componentName = upperFirst(camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, '')));

  Vue.component(`Base${componentName}`, componentConfig.default || componentConfig);
});
